<template>
  <!-- HERO -->
  <section class="py-16 md:py-24">
    <div class="max-w-page mx-auto px-6">
      <div class="max-w-3xl">
        <span class="inline-block rounded-badge bg-white border border-stone text-primary text-xs font-medium tracking-label uppercase px-3 py-1">
          Birlikte Çalışalım
        </span>
        <h1 class="mt-6 text-4xl md:text-5xl lg:text-6xl font-medium text-primary tracking-display leading-[0.95]">
          Bloqin ekosistemine<br />katkı sağla.
        </h1>
        <p class="mt-6 text-graphite text-base md:text-lg leading-relaxed">
          Advisory board üyeliği, stratejik ortaklık, gayrimenkul sponsorluğu veya farklı bir
          rolle Bloqin yolculuğunda yer almak istiyorsan formu doldur. Kısa süre içinde sana dönüş yaparız.
        </p>
      </div>
    </div>
  </section>

  <!-- ROLES — what we're looking for -->
  <section class="py-12 md:py-16">
    <div class="max-w-page mx-auto px-6">
      <div class="max-w-3xl mb-12">
        <p class="text-xs font-medium tracking-label uppercase text-graphite">Aradığımız Roller</p>
        <h2 class="mt-4 text-3xl md:text-4xl font-medium text-primary tracking-display leading-[0.95]">
          Birlikte inşa edelim.
        </h2>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        <div class="rounded-card bg-white border border-stone p-6">
          <span class="inline-flex w-10 h-10 rounded-full bg-secondary items-center justify-center text-primary">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>
          </span>
          <h3 class="mt-5 text-lg font-medium text-primary leading-tight">Advisory Board</h3>
          <p class="mt-2 text-sm text-graphite leading-relaxed">
            Finans, gayrimenkul veya blokzincir alanında deneyimli profesyoneller.
            Stratejik yön gösterme ve sektörel uzmanlık.
          </p>
        </div>

        <div class="rounded-card bg-parchment border border-stone p-6">
          <span class="inline-flex w-10 h-10 rounded-full bg-secondary items-center justify-center text-primary">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/></svg>
          </span>
          <h3 class="mt-5 text-lg font-medium text-primary leading-tight">Stratejik Ortaklar</h3>
          <p class="mt-2 text-sm text-graphite leading-relaxed">
            Distribütörler, kurumsal yatırımcılar ve gayrimenkul portföyü olan ortaklar.
          </p>
        </div>

        <div class="rounded-card magicpattern text-white p-6">
          <span class="inline-flex w-10 h-10 rounded-full bg-secondary items-center justify-center text-primary">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/></svg>
          </span>
          <h3 class="mt-5 text-lg font-medium leading-tight">Gayrimenkul Sponsorları</h3>
          <p class="mt-2 text-sm text-stone/80 leading-relaxed">
            Tokenize edilebilir nitelikli mülk sahipleri, geliştiriciler ve emlak yatırım fonları.
          </p>
        </div>

        <div class="rounded-card bg-secondary text-primary p-6">
          <span class="inline-flex w-10 h-10 rounded-full bg-primary items-center justify-center text-secondary">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
          </span>
          <h3 class="mt-5 text-lg font-medium leading-tight">Teknoloji Ortakları</h3>
          <p class="mt-2 text-sm leading-relaxed">
            Smart kontrat geliştirme, custody çözümleri, ödeme altyapısı ve oracle servisleri.
          </p>
        </div>

        <div class="rounded-card bg-white border border-stone p-6">
          <span class="inline-flex w-10 h-10 rounded-full bg-secondary items-center justify-center text-primary">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>
          </span>
          <h3 class="mt-5 text-lg font-medium text-primary leading-tight">Hukuk &amp; Regülasyon</h3>
          <p class="mt-2 text-sm text-graphite leading-relaxed">
            SPK, BDDK ve uluslararası sermaye piyasası regülasyonlarında uzman danışmanlar.
          </p>
        </div>

        <div class="rounded-card bg-parchment border border-stone p-6">
          <span class="inline-flex w-10 h-10 rounded-full bg-secondary items-center justify-center text-primary">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"/></svg>
          </span>
          <h3 class="mt-5 text-lg font-medium text-primary leading-tight">Kurumsal Yatırımcılar</h3>
          <p class="mt-2 text-sm text-graphite leading-relaxed">
            Aile ofisleri, kurumsal fonlar ve yüksek hacimli yatırımcılar için özel ilişkiler.
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- APPLICATION FORM -->
  <section id="apply" class="py-16 md:py-24">
    <div class="max-w-page mx-auto px-6">
      <ApplicationForm />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ApplicationForm from '@/components/ApplicationForm.vue';

export default defineComponent({
  name: 'ApplyView',
  components: {
    ApplicationForm,
  },
});
</script>
